import React, { useEffect, useState } from "react";
import { base_url } from "../../Api/Api";
import ItemNotification from "./itemNotification";
import SkltnTicketItem from "../Tickets/skltn/sklnTicketItem";

const Notification = (props) => {
  const [state, setState] = useState({
    data: [],
    statusData: false,
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    base_url
      .get(`notification_list`)
      .then((response) => {
        setState({
          ...state,
          data: response.data,
          statusData: response.data.length == 0,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            props.history.push(`/Entrance`);
          }
        }
      });
  }, []);

  return (
    <div className="tickets notification_pages">
      <div className="contain">
        <div className="ticketsDetail">
          <div className="title">
            <span className="ticketTtl">اعلانات</span>
          </div>
          <div className="ticketBody">
            {state.data.length == 0 ? (
              state.statusData ? (
                <span className="no-content">اطلاعاتی وجود ندارد</span>
              ) : (
                <SkltnTicketItem />
              )
            ) : (
              state.data.map((item) => (
                <ItemNotification key={item.id} data={item} />
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notification;
